import React from 'react';

export default function ResetFilterSVG() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7662 4.4433C18.7662 4.7099 18.5874 4.88763 18.3194 4.88763H14.7452C14.4772 4.88763 14.2985 4.7099 14.2985 4.4433C14.2985 4.1767 14.4772 3.99897 14.7452 3.99897H18.3194C18.5874 3.99897 18.7662 4.1767 18.7662 4.4433ZM21 4.4433C21 6.88712 18.9895 8.88661 16.5323 8.88661C15.9068 8.88661 15.3707 8.75331 14.8346 8.53114L11.1711 12.1747V18.2175C11.1711 18.3953 11.0817 18.5286 10.903 18.6174L8.22238 19.9504C8.10979 20.062 7.95566 19.9504 7.82029 19.9504C7.68625 19.8616 7.5969 19.6838 7.5969 19.5505V12.1747L0.135841 4.75433C0.00180987 4.62104 -0.0428666 4.4433 0.0464874 4.26557C0.135841 4.08784 0.269872 3.99897 0.44858 3.99897H12.1093C12.3327 1.77732 14.2542 0 16.5323 0C18.9895 0 21 1.99949 21 4.4433ZM13.9857 8.08681C12.9135 7.37588 12.1986 6.22062 12.0646 4.88763H1.52083L8.35641 11.6859C8.44576 11.7748 8.49044 11.8636 8.49044 11.9969V18.8396L10.2775 17.9509V11.9969C10.2775 11.8636 10.3222 11.7748 10.4116 11.6859L13.9857 8.08681ZM20.1065 4.4433C20.1065 2.48825 18.4981 0.888661 16.5323 0.888661C14.5665 0.888661 12.9581 2.48825 12.9581 4.4433C12.9581 6.39836 14.5665 7.99795 16.5323 7.99795C18.4981 7.99795 20.1065 6.39836 20.1065 4.4433Z"
        fill="#35198E"
      />
    </svg>
  );
}
